
export default class FormUsuario {
    constructor() {
        this.form = this.form();
    }

    form() {
        return {
            fechar: false,
            items: [
                { type: 'T', text: "Nome", item_id: 'nome', valor: null, prepIcon: 'person', class: "input-required", mask: null },
                { type: 'T', text: "Sobrenome", item_id: 'sobrenome', valor: null, prepIcon: 'person', class: null, mask: null },
                { type: 'T', text: "E-mail (Login)", item_id: 'email', valor: null, prepIcon: 'mail', class: "input-required", mask: null },
                { type: 'T', text: "Telefone", item_id: 'telefone', valor: null, prepIcon: 'phone', class: null, mask: "(##) ##### - ####" },
                { type: 'D', text: "Data de nascimento", item_id: 'dtNascimento', valor: null, data: null, index: this.menu0, class: null, mask: "##-##-####" },
            ]
        };
    }

}





// WEBPACK FOOTER //
// ./src/domain/conta/usuario/FormUsuario.js